export default function initBootstrapCustom() {
	const $page = jQuery('html, body');

	jQuery('.accordion-item').on('shown.bs.collapse', e => {
		const $item = jQuery(e.currentTarget);
		const offsetTop = $item.offset().top  - extraOffset();

		if (offsetTop < jQuery(window).scrollTop()) {
			$page.stop().animate({ scrollTop: offsetTop });
		}
	});

	function extraOffset() {
		let totalHeight = 0;
		jQuery('#header').each(function() {
			let $box = jQuery(this);
			totalHeight += ($box.css('position') === 'fixed' || $box.css('position') === 'sticky') ? $box.outerHeight() : 0;
		});
		return totalHeight;
	}
	if($('#timeline').length  ){
		$( window ).on( "resize" , function() {
			// $( "#log" ).append( "<div>Handler for `resize` called.</div>" );
			const element = document.getElementById("timeline");
			let y = element.scrollHeight;
			$('.timeline__bar').height(y);
		}).resize();
	};

}